import { render, staticRenderFns } from "./SupportRequestModal.vue?vue&type=template&id=20dcbdda"
import script from "./SupportRequestModal.vue?vue&type=script&lang=js"
export * from "./SupportRequestModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports